import React from 'react'
import './Styles.css';

const Loading = () => {
  return (
    <div className='parent'>
        <div className="progress">
            <div className="color"></div>
        </div>
    </div>
  )
}

export default Loading